class Subscribe {
    constructor() {
        this.clientList = {};
        this.instance = null;
    }

    static getInstance() {
        if (!this.instance) {
            return this.instance = new Subscribe();
        }
        
        return this.instance;
    }

    listen(key, fn) {
        if (!this.clientList[key]) {
            this.clientList[key] = [];
        }

        let isExit = false;
        for (let i =0, len = this.clientList[key].length; i < len; i++) {
            if (fn === this.clientList[key][i++]) {
                isExit = true;
                break;
            }
        }

        if (!isExit) {
            this.clientList[key].push(fn);
        }
    }

    trigger() {
        const key = Array.prototype.shift.call(arguments);
        this.clientList[key].map(item => {
            item.apply(this, arguments);
        });
    }

    remove(key, fn) {
        const isValidKey = key in this.clientList;
        if(!isValidKey) return;
        
        if (!fn || fn.length === 0) {
            this.clientList[key].length = 0;
        } else {
            for (let i = this.clientList[key].length; i>=0; i--) {
                if (fn === this.clientList[key][i]) {
                    this.clientList[key].splice(i, 1);
                }
            }
        }
    }
}

export default Subscribe.getInstance();

